import { IGetReviewsData, IGetReviewsResponse, ILeaveAReviewData } from "../api/types";
import $api from "../http";
import { IReviewAvailability } from "../models/Review";

class ReviewClass {
  async getReviewAvailability() {
    return await $api.get<IReviewAvailability>("api/review-availability");
  }

  async getAll(data: IGetReviewsData) {
    const response = await $api.get<IGetReviewsResponse>(
      `api/review?currentPage=${data.currentPage}&pageSize=${data.pageSize}&gymListingId=${data.gymListingId}`
    );
    return response.data;
  }

  async leaveAReview(data: ILeaveAReviewData) {
    return await $api.post<{}>("api/review", {
      ...data,
    });
  }
}

export const ReviewService = new ReviewClass();
